import type { SelectElementWithPicker } from "@shared/Components/Dropdown/Dropdown.types";

export function openNativeSelect(select: HTMLSelectElement): void {
  const selectWithPicker = select as SelectElementWithPicker;

  select.focus();

  try {
    selectWithPicker.showPicker?.();
  } catch {
    // Some browsers only support focusing native selects programmatically.
  }
}
